export const agreementRequest = [{
  id: true,
  identifier: true
}];
